<template>
  <div>
    <div class="row">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">IndexPage</el-breadcrumb-item>
        <el-breadcrumb-item>Records</el-breadcrumb-item>
        <el-breadcrumb-item>Record</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="row filter">

      <div class="filter-item clear">
        <div class="item-head ">
          <span>提交日期:</span>
        </div>
        <div class="item-content">
          <el-date-picker
            v-model="filter['date']"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            :editable=false
            :clearable=false
            :picker-options=datepicker.options
            :default-time="['00:00:00','23:59:59']">
          </el-date-picker>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>狀態:</span>
        </div>
        <div class="item-content">
          <el-select v-model="filter.status" placeholder="請選擇狀態">
            <el-option v-for="item in [{label:'全部',value:''},{label:'已提交',value:'1'},{label:'已鎖定',value:'2'},{label:'已分配',value:'3'}]"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"

            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>查詢關鍵字:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.keyword" placeholder="請輸入查詢關鍵字"></el-input>
        </div>
      </div>


    </div>

    <div class="row">
      <el-button type="primary" @click.native="process">Query</el-button>
    </div>

    <div class="row">
      <template>
        <el-table
          @cell-click="recordDetailShow"
          :data.sync="records"
          stripe
          border
          style="">

          <el-table-column
            prop="owner"
            label="OWNER"
            width="120">
          </el-table-column>

          <el-table-column
            prop="phone"
            label="PHONE"
            width="120">
          </el-table-column>

          <el-table-column
            prop="inspectDate"
            label="InspectDate"
            width="150">
          </el-table-column>

          <el-table-column
            prop="weather"
            label="Weather"
            width="120">
          </el-table-column>

          <el-table-column
            prop="developmentName"
            label="DEVELOP"
            width="120">
          </el-table-column>

          <el-table-column
            prop="towerName"
            label="TOWER"
            width="120">
          </el-table-column>

          <el-table-column
            prop="floorName"
            label="FLOOR"
            width="120">
          </el-table-column>

          <el-table-column
            prop="flatName"
            label="FLAT"
            width="120">
          </el-table-column>


          <el-table-column
            prop="status"
            label="STATUS"
            width="120"
            :formatter="statusFormatter">
          </el-table-column>

          <el-table-column
            prop="contractor"
            label="Contractor"
            width="120">
          </el-table-column>

          <el-table-column
            prop="createAt"
            label="CREATE"
            width="150">
          </el-table-column>

          <el-table-column
            fixed="right"
            label="OPERATIONS"
            width="300">
            <template slot-scope="scope">

              <el-button v-if="scope.row.status == 1"
                         type="primary"
                         size="mini"
                         @click="lock(scope.$index, scope.row)">锁定
              </el-button>

              <el-button v-if="scope.row.status == 2"
                         size="mini"
                         type="primary"
                         @click="edit(scope.$index, scope.row)">分配
              </el-button>

              <el-button
                size="mini"
                type="primary"
                @click="update(scope.$index, scope.row)">修改
              </el-button>

              <el-button ref="download"
                         :disabled="downloadDisabled"
                size="mini"
                type="primary"
                @click="downloadPdf(scope.$index, scope.row,$event)">导出
              </el-button>

            </template>
          </el-table-column>

        </el-table>
      </template>
    </div>

    <div class="row">
      <el-pagination
        @size-change="process"
        @current-change="process"
        :current-page.sync="page.currentPage"
        :page-sizes="[10, 50, 100, 500]"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>


    <!-- new form-->
    <div class="row">
      <el-dialog title="Contractor" :visible.sync="form.dialogFormVisible" @close="close">

        <input hidden v-model="form.id">

        <el-form :model="form" ref="form" label-width="120px" class="demo-ruleForm"
                 :rules="{contractor:[{required:true,message:'请输入Contractor',trigger:'blur'}]}" action="/record/edit">

          <el-form-item label="Contractor" prop="contractor">
            <el-input v-model="form.contractor"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="form.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit('form',{id: form.id,contractor: form.contractor})">确 定</el-button>
        </div>
      </el-dialog>
    </div>


    <!--    更新记录 -->
    <div class="row">
      <el-dialog title="Edit" :visible.sync="editForm.dialogFormVisible"
                 @close="editForm.data = {};editForm.dialogFormVisible = false;">

        <input hidden v-model="editForm.data.id">

        <el-form :model="editForm.data" ref="editForm" label-width="120px" class="demo-ruleForm"
                 :rules="editForm.rule" action="/record/edit">
          <el-form-item label="Owner" prop="owner">
            <el-input v-model="editForm.data.owner"></el-input>
          </el-form-item>

          <el-form-item label="Phone" prop="phone">
            <el-input v-model="editForm.data.phone"></el-input>
          </el-form-item>

          <el-form-item label="Weather" prop="weather">
            <el-select v-model="editForm.data.weather" placeholder="请选择Weather">
              <el-option label="晴" value="晴"></el-option>
              <el-option label="多云" value="多云"></el-option>
              <el-option label="陰" value="陰"></el-option>
              <el-option label="雨" value="雨"></el-option>
              <el-option label="雪" value="雪"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Status" prop="status">
            <el-select v-model.sync="editForm.data.status" placeholder="请选择Status">
              <el-option label="已提交" value="1"></el-option>
              <el-option label="已鎖定" value="2"></el-option>
              <el-option label="已分配" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Contractor" prop="contractor">
            <el-input v-model="editForm.data.contractor"></el-input>
          </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="editForm.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit('editForm',editForm.data)">确 定</el-button>
        </div>
      </el-dialog>
    </div>


    <div class="row">
      <el-dialog title="RecordDetail" :visible.sync="recordDetail.visible" @close="recordDetailClose" width="80%">

        <el-table
          :data.sync="recordDetail.data"
          stripet
          border
          style="">
          <el-table-column
            prop="locationName"
            label="Location"
            min-width="120">
          </el-table-column>

          <el-table-column
            prop="tradeName"
            label="Trade"
            min-width="120">
          </el-table-column>

          <el-table-column
            prop="itemName"
            label="Work items"
            min-width="120">
          </el-table-column>

          <el-table-column
            prop="typeName"
            label="Defect type"
            min-width="120">
          </el-table-column>

          <el-table-column
            prop="defectNumber"
            label="Number"
            min-width="40">
          </el-table-column>

          <el-table-column
            prop="remark"
            label="Remark"
            width="360">
          </el-table-column>

        </el-table>
      </el-dialog>

    </div>


  </div>
</template>

<script>
  import * as constants from "../../utils/constants";

  export default {
    name: "Record",
    data: function () {
      return {
        downloadDisabled:false,
        filter: {
          keyword:'',
          status:''
        },
        records: [],
        total: 0,
        datepicker:{
          options:{
            onPick: ({maxDate, minDate}) => {
              this.datepicker.pickerMinDate = minDate.getTime();
              if (maxDate) {
                this.pickerMinDate = ''
              }
            },
            disabledDate: (time) => {
              //选好小值 没选大值
              if (this.datepicker.pickerMinDate !== '') {
                const day60 = (60 - 1) * 24 * 3600 * 1000;
                let maxTime = this.datepicker.pickerMinDate + day60;
                if (maxTime > new Date().getTime() + 24 * 3600 * 1000 ) {
                  maxTime = new Date().getTime() + 24 * 3600 * 1000
                }
                return time.getTime() > maxTime
              }
              //大小值均已选
              return time.getTime() > Date.now() + 24 * 3600 * 1000;
            },
            shortcuts: [{
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近二个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                picker.$emit('pick', [start, end]);
              }
            }]
          }
        },
        page: {
          pageSize: 10,
          currentPage: 1
        },
        form: {
          contractor: '',
          id: null,
          labelWidth: '120px',
          dialogFormVisible: false,
        },
        //修改表单
        editForm: {
          data: {},
          dialogFormVisible: false,
          rule: {
            owner: [{required: true, message: "請輸入Owner", trigger: 'blur'}],
            phone: [{required: true, message: '请输入Phone', trigger: 'blur'}],
            weather: [{required: true, message: '请選擇Weather', trigger: 'change'}],
            status: [{required: true, message: '请選擇Status', trigger: 'change'}]
          }
        },
        recordDetail: {
          //将要展示的数据
          data: [],
          visible: false,
          pageSize: 10
        }
      };
    },
    created: function () {
      this.process();
    },
    methods: {
      close: function () {
        this.form.itemId = null;
        this.form.itemName = "";
      },
      recordDetailClose() {
        this.recordDetail.data = [];
        this.recordDetail.visible = false;
      },
      recordDetailShow(row, column) {
        if (column.label === "OPERATIONS")
          return;
        this.recordDetail.data = row.recordDetails;
        this.recordDetail.visible = true;
      },
      statusFormatter: function (row, column, cellValue) {
        if (cellValue == 1) {
          return "已提交";
        }
        if (cellValue == 2) {
          return "已锁定";
        }
        if (cellValue == 3) {
          return "已分配";
        }
        return cellValue;
      },
      process: function () {
        this.$http.post("/record/list", {
          filter: this.filter,
          pageSize: this.page.pageSize,
          currentPage: this.page.currentPage
        }).then(response => {
          this.records = response.data.data.data;
          this.total = response.data.data.total;
        });
      },
      submit: function (formId, data) {
        this.$refs[formId].validate(
          validate => {
            if (!validate) {
              return false;
            }
            this.$http.post(this.$refs[formId].$attrs.action, data).then(response => {
              if (response.data.code === "1") {
                this.form.dialogFormVisible = false;
                this.editForm.dialogFormVisible = false;
                this.$message.success("操作成功");
                this.process();
                return true;
              }
            });
          }
        );
      },
      //分配
      edit: function (index, row) {
        this.form.id = row.id;
        this.form.dialogFormVisible = true;
      },
      //更新记录
      update(index, row) {
        let data = {};
        data['weather'] = row.weather;
        data['owner'] = row.owner;
        data['phone'] = row.phone;
        data['status'] = row.status + '';
        data['contractor'] = row.contractor;
        data['id'] = row.id;
        this.editForm.data = data;
        this.editForm.dialogFormVisible = true;
      },
      lock: function (index, row) {
        this.$http.post("/record/edit", {
          id: row.id,
          status: 2
        }).then(response => {
          if (response.data.code == "1") {
            this.$message.success("锁定成功");
            this.process();
          }
        });
      },
      downloadPdf(index, row,event) {
/*        this.$http.post("/record/export", {id: row.id}).then(response => {
          this.$message.success("下载成功");
        });*/
        this.downloadDisabled = true;

        try {
          let token = sessionStorage.getItem(constants.TOKEN);
          if(!token){
            this.$message.error("无权限");
            return ;
          }
          let url = process.env.HOST_NAME + "/record/export?authorization=" + token + "&id=" + row.id;
          let a = document.createElement('a');
          a.href = url;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.remove();
        }finally {
          setTimeout(()=>{
            this.downloadDisabled = false;
          },6000);
        }

      },
      del: function (index, row) {
        this.$confirm('确定删除该记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/item/delete", {
            itemId: row.itemId,
          }).then(response => {
            if (response.data.code == "1") {
              this.$message.success("删除成功");
              this.process();
            }
          })
        });

      }
    }
  }
</script>

<style scoped>

  .filter {
    border: 1px solid #DCDFE6;
  }

  .filter > .filter-item {
    border-bottom: 1px dashed #DCDFE6;
    position: relative;
    display: block;
    padding: 5px 0 5px 0;
  }

  .filter > .filter-item:last-of-type {
    border-bottom: none;
  }

  .filter > .filter-item > .item-head {
    display: inline-block;
    width: 150px;
    float: left;
    line-height: 32px;
    padding-left: 10px;
  }

  .filter > .filter-item > .item-content {
    display: block;
    float: left;
    margin-left: 10px;
  }

  .clear {
    display: block;
    overflow: hidden;
  }


</style>



// WEBPACK FOOTER //
// src/components/records/Record.vue